<template>
  <div>
    <nav class="navbar fixed-top bg-light">
      <div class="col-8 px-0">
        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="Search" v-model="search">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" @click="searchContacts()">Sök</button>
          </div>
        </div>
      </div>
    </nav>
    <div style="margin-top: 80px">
    <div class="card" v-for="c in contacts" :key="c.id" v-if="c.givenName" @click="selectContact(c.id)" :class="contactBg(c.id)">
      <div class="">
        <div class="row m-4 align-items-center">
          <div class="col">
            {{ c.givenName }} {{ c.surname }}<br>
            {{ c.jobTitle }}<br>
            {{ c.companyName }}
          </div>
          <div class="col-1">
            <router-link :to="`/customers/${id}/add-outlook-contact/${c.id}`" class="btn btn-secondary" v-if="selectedId === c.id">
              <i class="fas fa-caret-right"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import appService from '../appService'

export default {
  props: ['id'],

  data () {
    return {
      contacts: {},
      search: '',
      selectedId: null
    }
  },

  methods: {
    searchContacts() {
      if (this.search) {
        appService.searchOutlookContacts(this.search)
        .then(result => this.contacts = result)
      }
    },

    selectContact (id) {
      if (this.selectedId === id) {
        this.selectedId = null
      } else {
        this.selectedId = id
      }
    },

    contactBg (id) {
      return [
        id === this.selectedId ?  'text-white bg-info' : ''
      ]
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/OutlookContactSearch.vue